import React, { useState, useEffect } from "react";
import AddCircle from '@mui/icons-material/AddCircleRounded';
import SearchIcon from '@mui/icons-material/SearchTwoTone';
import { InputGroup, Button, Modal, Col, Row } from "react-bootstrap";
import { FormProvider, useForm, Controller } from "react-hook-form";
import _ from "lodash";
import DataGrid from "./DataGrid";
import AddEditeModal from "./AddEditeModal";
import { Route, useLocation, Link, useNavigate } from "react-router-dom";
import ApiRoleManager from "../../../core/api/api.roleManager";
import { tools } from "../../../core/utils/tools";
import GlobalFormControl from "../_Components/GlobalFormControl";


export const Roles = () => {

  const [listData, setListData] = useState([{}]);
  const { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };

  let location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const [showModalEditRole, setShowModalEditRole] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState(null);

  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;

  useEffect(() => {
    (async () => {
      try {
        //دریافت لیست نقش ها
        const data = await ApiRoleManager.getAllAdminRoles({
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
          globalSearch: searchParams.get("globalSearch"),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  const onSubmit =
    async (data) => {
      const apiData = await ApiRoleManager.getAllAdminRoles({ pageSize: data.pageSize, pageNumber: getValues("pageNumber"), globalSearch: data.globalSearch });
      setListData(apiData);
      setValue("totalCount", apiData.totalCount);
      tools.setPageNumber(data, searchParams, setValue);
      var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
      navigate(`/roles?${queryString}`);
    }


  return (
    <div>
      {(!_.isEmpty(location.state) && !_.isEmpty(location.state?.id)) ?
        <AddEditeModal />
        :
        <></>
      }
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              مدیریت نقش ها
                        </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              لیست نقش ها
                        </span>
          </h3>
          <div className="card-toolbar">
            <Button
              onClick={() => {
                setSelectedRoleId(0);
                setShowModalEditRole(true);
              }}
            >
              <AddCircle className='mr-1' />
                          افزودن نقش
                        </Button>
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods} >
            <form id="form" key={1} onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className='border-top pt-3'>
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder='جستجو ...'
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}><SearchIcon /></Button>

                </InputGroup>
              </div>
              {/* table */}
              <Col xs='12' className='tb-reponsive px-0'>
                <DataGrid data={listData} setShowModalEditRole={setShowModalEditRole} setSelectedRoleId={setSelectedRoleId}
                />
              </Col>
              {showModalEditRole && (
                <AddEditeModal
                  showModalEditRole={showModalEditRole}
                  setShowModalEditRole={setShowModalEditRole}
                  selectedRoleId={selectedRoleId}
                />
              )}
            </form>
          </FormProvider>
        </div>

        {/* Start Modal */}
        {/* <Modal centered size='md' show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>ایجاد نقش جدید</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form noValidate autoComplete="off">
                            <Row>
                                <Col xs='12'>
                                    <TextField
                                        required
                                        label="نام مجوز"
                                        margin="normal"
                                        variant="outlined"
                                        size='small'
                                    />
                                </Col>
                                <Col xs='12'>
                                    <FormControlLabel
                                        control={
                                            <Checkbox color='primary' checked={checked} onChange={handleChange} />
                                        }
                                        label="پیش فرض "
                                    />
                                </Col>
                                <Col xs='12' className='text-muted'>
                                    <span className='pl-3'>
                                    به عنوان پیش فرض به کاربران جدید اختصاص دهید
                                    </span>
                                </Col>
                            </Row>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={handleClose}>
                            <SaveIcon />  ذخیره
                        </Button>
                        <Button variant="danger" onClick={handleClose}>
                            <CloseIcon />  بستن
                         </Button>
                    </Modal.Footer>
                </Modal>*/}
      </div>
    </div>
  );
}
